/* ── ACCORDION ────────────────────────────────── */
document.querySelectorAll('.accordion-trigger').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.accordion-item');
    const isOpen = item.classList.contains('open');
    item.closest('.accordion-list')
        .querySelectorAll('.accordion-item.open')
        .forEach(i => {
          i.classList.remove('open');
          i.querySelector('.accordion-trigger').setAttribute('aria-expanded', 'false');
        });
    if (!isOpen) {
      item.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }
  });
});

/* ── TABS ─────────────────────────────────────── */
document.querySelectorAll('.cat-tab').forEach(tab => {
  tab.addEventListener('click', () => {
    document.querySelectorAll('.cat-tab').forEach(t => t.classList.remove('active'));
    tab.classList.add('active');
    const cat = tab.dataset.cat;
    document.querySelectorAll('.faq-section').forEach(s => {
      s.classList.toggle('hidden', cat !== 'all' && s.dataset.cat !== cat);
    });
    document.querySelector('.faq-section:not(.hidden)')
            ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    clearSearch();
  });
});

/* ── SEARCH ───────────────────────────────────── */
const searchInput = document.getElementById('faq-search');
const searchClear = document.getElementById('search-clear');
const noResults   = document.getElementById('no-results');

function clearSearch() {
  searchInput.value = '';
  searchClear.classList.remove('visible');
  document.querySelectorAll('.accordion-item').forEach(i => {
    i.classList.remove('hidden');
    const q = i.querySelector('.accordion-q');
    q.innerHTML = q.textContent;
  });
  noResults.classList.remove('visible');
  const activeCat = document.querySelector('.cat-tab.active').dataset.cat;
  document.querySelectorAll('.faq-section').forEach(s => {
    s.classList.toggle('hidden', activeCat !== 'all' && s.dataset.cat !== activeCat);
  });
}

searchInput.addEventListener('input', () => {
  const q = searchInput.value.trim().toLowerCase();
  searchClear.classList.toggle('visible', q.length > 0);
  if (!q) { clearSearch(); return; }

  document.querySelectorAll('.cat-tab').forEach(t => t.classList.remove('active'));
  document.querySelector('[data-cat="all"]').classList.add('active');
  document.querySelectorAll('.faq-section').forEach(s => s.classList.remove('hidden'));

  let total = 0;
  document.querySelectorAll('.accordion-item').forEach(item => {
    const kw   = (item.dataset.keywords || '').toLowerCase();
    const qEl  = item.querySelector('.accordion-q');
    const rawQ = qEl.textContent.toLowerCase();
    const body = (item.querySelector('.accordion-body') || {}).textContent?.toLowerCase() || '';
    const match = rawQ.includes(q) || kw.includes(q) || body.includes(q);
    item.classList.toggle('hidden', !match);
    if (match) {
      total++;
      const re = new RegExp(`(${q.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')})`, 'gi');
      qEl.innerHTML = qEl.textContent.replace(re, '<mark>$1</mark>');
    } else {
      qEl.innerHTML = qEl.textContent;
    }
  });

  document.querySelectorAll('.faq-section').forEach(s => {
    s.classList.toggle('hidden', s.querySelectorAll('.accordion-item:not(.hidden)').length === 0);
  });
  noResults.classList.toggle('visible', total === 0);
});
searchClear.addEventListener('click', () => { clearSearch(); searchInput.focus(); });

/* ── MODAL ────────────────────────────────────── */
const overlay = document.getElementById('modal-overlay');

function openModal() {
  overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  overlay.querySelector('.modal').scrollTop = 0;
}
function closeModal() {
  overlay.classList.remove('open');
  document.body.style.overflow = '';
}

document.getElementById('open-ticket').addEventListener('click', openModal);
document.getElementById('open-ticket-nr')?.addEventListener('click', openModal);
document.querySelectorAll('.js-open-ticket').forEach(el => el.addEventListener('click', openModal));

document.getElementById('modal-close').addEventListener('click', closeModal);
overlay.addEventListener('click', e => { if (e.target === overlay) closeModal(); });
document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });

/* ── DYNAMIC FIELDS ───────────────────────────── */
const sujetSel  = document.getElementById('sujet');
const dynFields = document.querySelectorAll('.dynamic-field');

/* ── SUBJECT HINTS ────────────────────────────── */
const SUBJECT_HINTS = {
  livraison:     '📬 Ton <strong>lien de suivi</strong> se trouve dans l\'email de confirmation d\'expédition. Un statut "bloqué" depuis moins de 24h, c\'est normal — le transporteur doit d\'abord scanner ton colis. <a href="#" data-faq-tab="livraison">→ Voir la FAQ Livraison</a>',
  retard:        '⏳ Les délais peuvent varier selon la destination et la période. Un statut bloqué ≠ colis perdu. <a href="#" data-faq-tab="livraison">→ Voir la FAQ Livraison</a>',
  perdu:         '🔍 Un colis "bloqué" n\'est <strong>pas forcément perdu</strong>. On recommande d\'attendre <strong>5 jours ouvrés</strong> sans mouvement avant d\'ouvrir une enquête. <a href="#" data-faq-tab="livraison">→ Voir la FAQ Livraison</a>',
  annulation:    '⚠️ L\'annulation n\'est possible <strong>qu\'avant l\'expédition</strong>. Contacte-nous au plus vite ! <a href="#" data-faq-tab="commande">→ Voir la FAQ Commandes</a>',
  retour:        '↩️ Les retours sont acceptés dans les <strong>30 jours</strong> suivant la réception, articles non utilisés dans leur emballage d\'origine. <a href="#" data-faq-tab="commande">→ Voir la FAQ Commandes</a>',
  remboursement: '💸 Le remboursement est traité sous <strong>5 à 7 jours ouvrés</strong> après réception et vérification du retour. <a href="#" data-faq-tab="commande">→ Voir la FAQ Commandes</a>',
  paiement:      '💳 On accepte uniquement la <strong>carte bancaire</strong>. Un refus est souvent lié à ta banque (authentification 3D-Secure, limite de paiement en ligne). Réessaye ou contacte ta banque directement.',
  adresse:       '⚠️ La modification d\'adresse n\'est possible <strong>qu\'avant l\'expédition</strong> — contacte-nous au plus vite !',
  abime:         '📸 Prépare des <strong>photos claires</strong> du colis et du produit endommagé avant d\'envoyer ta demande.'
};

sujetSel.addEventListener('change', () => {
  const val = sujetSel.value;
  dynFields.forEach(f => {
    const targets = (f.dataset.for || '').split(',');
    f.classList.toggle('visible', targets.includes(val));
  });
  document.getElementById('err-sujet').classList.remove('visible');
  sujetSel.classList.remove('invalid');

  const hintEl = document.getElementById('subject-hint');
  const hintHtml = SUBJECT_HINTS[val];

  if (hintHtml) {
    hintEl.innerHTML = hintHtml;
    hintEl.hidden = false;
    hintEl.querySelectorAll('[data-faq-tab]').forEach(a => {
      a.addEventListener('click', e => {
        e.preventDefault();
        closeModal();
        const tab = document.querySelector(`.cat-tab[data-cat="${a.dataset.faqTab}"]`);
        if (tab) { tab.click(); tab.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
      });
    });
  } else {
    hintEl.hidden = true;
    hintEl.innerHTML = '';
  }
});

/* ── FORM SUBMIT ──────────────────────────────── */
document.getElementById('form-submit').addEventListener('click', async () => {
  let valid = true;

  const sujet   = sujetSel.value;
  const email   = document.getElementById('email').value.trim();
  const message = document.getElementById('message').value.trim();

  if (!sujet) {
    document.getElementById('err-sujet').classList.add('visible');
    sujetSel.classList.add('invalid');
    valid = false;
  }
  if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    document.getElementById('err-email').classList.add('visible');
    document.getElementById('email').classList.add('invalid');
    valid = false;
  } else {
    document.getElementById('err-email').classList.remove('visible');
    document.getElementById('email').classList.remove('invalid');
  }
  if (!message) {
    document.getElementById('err-message').classList.add('visible');
    document.getElementById('message').classList.add('invalid');
    valid = false;
  } else {
    document.getElementById('err-message').classList.remove('visible');
    document.getElementById('message').classList.remove('invalid');
  }

  if (!valid) return;

  const btn    = document.getElementById('form-submit');
  const errMsg = document.getElementById('submit-error');
  const apiUrl = window.GDL_CONTACT_API_URL;

  btn.textContent = 'Envoi en cours…';
  btn.disabled = true;
  errMsg.style.display = 'none';

  try {
    if (!apiUrl) throw new Error('API URL not configured');

    const res = await fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sujet,
        email,
        message,
        orderNum:     (document.getElementById('order-num')?.value   || '').trim(),
        produitNom:   (document.getElementById('produit-nom')?.value  || '').trim(),
        paiementMode: (document.getElementById('paiement-mode')?.value || ''),
        newAddr:      (document.getElementById('new-addr')?.value     || '').trim(),
        tel:          (document.getElementById('tel')?.value          || '').trim(),
        website:      (document.getElementById('honeypot')?.value     || '') // honeypot
      })
    });

    if (!res.ok) throw new Error('Server error');

    document.getElementById('modal-form-wrap').style.display = 'none';
    document.getElementById('modal-success').classList.add('visible');

  } catch (e) {
    errMsg.style.display = 'block';
    btn.textContent = 'Envoyer le ticket →';
    btn.disabled = false;
  }
});
